import { MintgramURL } from "../index";
import { ApiResponse } from "../HttpClient";

export default {
  async startPayment(priceId: string): Promise<ApiResponse<any>> {
    return await MintgramURL.get(`v1/start_payment/${priceId}`, {});
  },
  async manageSubscription(): Promise<any> {
    return await MintgramURL.post("v1/payment/manage_portal", {}, {});
  },
  async promote(token: string): Promise<any> {
    return await MintgramURL.get(`v1/use_promo/${token}`, {});
  },
};
